var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6736_1724)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.47746 0C1.66251 0 1 0.647977 1 1.44505V13.0112C1 13.8082 1.66251 14.4562 2.47746 14.4562H8.72737V10.4823C8.72737 9.32972 9.65372 8.59573 10.4218 8.223C11.1019 7.89041 11.9344 7.68398 12.8256 7.61516V1.44505C12.8256 0.647977 12.1631 0 11.3481 0H2.47746ZM6.90986 4.33514C6.90986 4.33514 9.49542 6.14145 9.49542 7.58649C9.49542 8.49251 8.93844 9.03154 8.19971 9.03154C7.72481 9.03154 7.32613 8.73335 7.10333 8.52118C7.16783 9.08888 7.4727 9.54189 7.71308 9.81714C7.81861 9.93183 7.73067 10.1153 7.57237 10.1153H6.24148C6.08318 10.1153 6.0011 9.93756 6.10077 9.81714C6.34115 9.54189 6.64602 9.08888 6.71052 8.52118C6.48772 8.73335 6.08904 9.03154 5.61414 9.03154C4.87541 9.03154 4.31843 8.48678 4.31843 7.58649C4.31843 6.14145 6.90399 4.33514 6.90399 4.33514H6.90986ZM17 10.4823C17 11.4399 15.4111 12.2141 13.4529 12.2141C11.4947 12.2141 9.90583 11.4399 9.90583 10.4823C9.90583 9.52469 11.4947 8.75056 13.4529 8.75056C15.4111 8.75056 17 9.52469 17 10.4823ZM9.90583 13.3724V11.6406C9.90583 12.5983 11.4947 13.3724 13.4529 13.3724C15.4111 13.3724 17 12.5983 17 11.6406V13.3724C17 14.3358 15.4111 15.1099 13.4529 15.1099C11.4947 15.1099 9.90583 14.3358 9.90583 13.3781V13.3724ZM9.90583 16.2625V14.5307C9.90583 15.4884 11.4947 16.2625 13.4529 16.2625C15.4111 16.2625 17 15.4884 17 14.5307V16.2625C17 17.2259 15.4111 18 13.4529 18C11.4947 18 9.90583 17.2259 9.90583 16.2682V16.2625Z",
    fill: "#8C8989"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6736_1724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 18,
    fill: "white",
    transform: "translate(1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoker);
export default __webpack_public_path__ + "static/media/Poker.b3a95c522b1514e4358b312e06540c3c.svg";
export { ForwardRef as ReactComponent };